import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/sys/Login.vue'

// import Front_rms from '../views/front/Front_rms.vue'
// import modal from '../views/modal.vue'

// console.log(localStorage.my_param);

let mycode = "";

if (typeof localStorage.my_param !== "undefined") {
  // mycode = ((localStorage.my_param == "__q_strn|s") || (localStorage.my_param == "__q_strn|C")) ? "" : JSON.parse(localStorage.my_param.replace("__q_objt|", ""));
  mycode = localStorage.my_param.startsWith("__q_strn|") ? "" : JSON.parse(localStorage.my_param.replace("__q_objt|", ""));
} else {
  mycode = "";
}

// mycode = typeof localStorage.my_param !== "undefined" ? JSON.parse(localStorage.my_param.replace("__q_objt|", "")) : "";
mycode = typeof mycode.mycode !== "undefined" ? mycode.mycode : "";

// console.log(mycode);

let routes = [];

switch (mycode) {
  case 'jl_quotes':
    routes = [
      {
        path: '/',
        name: 'Quotes',
        component: () => import('../views/jl_quotes/Quotes.vue')
      },
    ]
    break;

  case 'matrox':
    routes = [
      {
        path: '/',
        name: 'Matrox',
        component: () => import('../views/matrox/Matrox.vue')
      },
    ]
    break;

  default:
    routes = [
      // {
      //   path: '/',
      //   name: 'Home',
      //   component: Home
      // },
      {
        path: '/',
        redirect: 'Login'
      },
      {
        path: '/login',
        name: 'Login',
        component: Login
      },
      {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      },
      {
        path: '/main',
        name: 'Main',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/sys/Main.vue')
      },
      {
        path: '/front',
        name: 'Front_rms',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/front/Front_rms.vue')
      },
      // {
      //   path: '/main/client',
      //   name: 'DataList',
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () => import(/* webpackChunkName: "about" */ '../views/base/DataList.vue')
      // },
      // {
      //   path: '/main/goods',
      //   name: 'Goods',
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () => import(/* webpackChunkName: "about" */ '../views/base/CategoryList.vue')
      // },
    ]

    break;
}

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
